// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3hkYb","info":"Note_info__1ryy2","note":"Note_note__3ryd8","actions":"Note_actions__11TVZ"};